export const gstAmountValidate = (gstArray,taxableAmount) => {
    const newErrors = {}; 
    const updatedArray = gstArray.map(item => {
        if(item?.gstFullData){
          return item?.gstFullData
        } else if (item?._id) {
          return item?._id; 
      } else {
            return {}
        } 
        })

        const totalBaseAmt =  updatedArray.reduce((total, item) => {
            const baseAmount = parseFloat(item?.bsAmt)
            return total + (baseAmount || 0); 
        }, 0);

        updatedArray.forEach((gst, index) => {
          if (parseFloat(totalBaseAmt) > parseFloat(taxableAmount)) {
            newErrors[`gst.${index}.baseAmount`] =
              "Base Amount Should be lessthen or equal taxable amount!";
          }
          if (!gst.bsAmt) {
            newErrors[`gst.${index}.baseAmount`] = "Base Amount Is Required!";
          }
          if (!gst.vId) {
            newErrors[`gst.${index}.companyId`] = "Company Name Is Required!";
          }
          if (!gst.vId && !gst.gstNo) {
            newErrors[`gst.${index}.gstNumber`] = "GST Number Is Required!";
          }
          if (!gst.prc) {
            newErrors[`gst.${index}.gstPercentage`] =
              "GST Percentage Is Required!";
          }
        });
      return newErrors;
    };
  